import React, {useEffect, useState} from 'react';
import { Flex} from "antd";
import {StyledCard} from "./DetailCards.styled";
import style from "./DetailCards.module.scss";
import {
    LeftOutlined
} from '@ant-design/icons';
import {TbListDetails} from "react-icons/tb";
import SpecificationsPopUp from "../specificationsPopUp/SpecificationsPopUp";
import {SpecificationsCardProps} from "../../../models";
const SpecificationsCard = ({product} : SpecificationsCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [activeSpecification, setActiveSpecification] = useState<any>()

    useEffect(() => {
        product?.productProperties?.length > 0 &&  setActiveSpecification(product?.productProperties[0])
    }, [product]);
    const openSpecificationsModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }
    return (
       <> <StyledCard className={'shadow-sm'} onClick={openSpecificationsModal}  >
           <Flex justify={"space-between"} align={"center"}>
               <Flex gap={"middle"}>
                   <span> <TbListDetails     className={style.icons}/> مشخصات </span>
               </Flex>
               <Flex gap={"small"}>
                   <span className={style.greyText}>{product?.productProperties?.length} مورد</span>
                   <span> <LeftOutlined className={style.icons}/> </span>
               </Flex>

           </Flex>
       </StyledCard>
       <SpecificationsPopUp product={product} open={open} onCansel={onCansel}/>
       </>
    );
};

export default SpecificationsCard;
